export default "__VITE_ASSET__c44b07c9__"